export default __webpack_public_path__ + "assets/images/2b9903e7c1e9a4aa531ca20017655305.png";